import { render, staticRenderFns } from "./pageFive.vue?vue&type=template&id=9fb10a50&scoped=true&"
import script from "./pageFive.vue?vue&type=script&lang=js&"
export * from "./pageFive.vue?vue&type=script&lang=js&"
import style0 from "./pageFive.vue?vue&type=style&index=0&id=9fb10a50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb10a50",
  null
  
)

export default component.exports